import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Tue Feb 12 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, PriceChangeReportDTOConverter, PriceStickersReportDTOConverter, SelloutIdentificationDetailDTOConverter, SelloutIdentificationDTOConverter, CompetitorPriceChangeReportDTOConverter, SelloutTerminationReportRowDTOConverter, SelloutTerminationReportFilterDTOConverter, CommonReleaseOverviewConverter, SelloutImpactReportFilterDTOConverter, SelloutImpactReportDetailRow4BOXDTOConverter, SelloutImpactReportDetailRowReleaseDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { List } from 'immutable';
export var ReportLayer =
/*#__PURE__*/
function () {
  function ReportLayer() {
    _classCallCheck(this, ReportLayer);
  }

  _createClass(ReportLayer, [{
    key: "getCompetitorPriceChangeReportDTOs",
    value: function getCompetitorPriceChangeReportDTOs(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var endpoint, _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.COMPETITOR_PRICE_CHANGE_REPORT);
                _context.prev = 1;
                _context.next = 4;
                return api(endpoint).post(params);

              case 4:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", (data.result || []).map(function (r) {
                  return _this.competitorPriceChangeReportDTOConverter.toObject(r, jsonConversions);
                }));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                logger.error(_context.t0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));
    }
    /**
     * Fetches DTOs for price change report
     * @param filter {PriceChangeReportRequest}
     */

  }, {
    key: "getPriceChangeReportDTOs",
    value: function getPriceChangeReportDTOs(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var _ref2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.PRICE_CHANGE_REPORT)).post(filter);

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;
                return _context2.abrupt("return", (data.result || []).map(function (dto) {
                  return _this2.priceChangeReportDTOConverter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                logger.error(_context2.t0);
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));
    }
    /**
     * Fetches DTOs for price stickers report
     * @param filter TODO: type
     */

  }, {
    key: "getPriceStickersReportDTOs",
    value: function getPriceStickersReportDTOs(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var _ref3, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.PRICE_STICKERS_REPORT)).post(filter);

              case 3:
                _ref3 = _context3.sent;
                data = _ref3.data;
                return _context3.abrupt("return", (data.result || []).map(function (dto) {
                  return _this3.priceStickersReportDTOConverter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                logger.error(_context3.t0);
                return _context3.abrupt("return", Promise.reject(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      }));
    } // FIXME: SKu change to AsyncOperationResultList and some common component

    /** Fetches DTOs for sellout identification report */

  }, {
    key: "getSelloutIdentificationReportDTOs",
    value: function getSelloutIdentificationReportDTOs() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        var _ref4, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_IDENTIFICATION_REPORT)).post();

              case 3:
                _ref4 = _context4.sent;
                data = _ref4.data;
                return _context4.abrupt("return", data.monitorId || (data.result || []).map(function (dto) {
                  return _this4.selloutIdentificationDTOConverter.toObject(dto, jsonConversions);
                }));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                logger.error(_context4.t0);
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 8]]);
      }));
    }
    /**
     * Fetches DTOs (and total rows count) for sellout identification report detail
     */

  }, {
    key: "getSelloutIdentificationReportDetailDTOs",
    value: function getSelloutIdentificationReportDetailDTOs(overview) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;

        var _ref5, data, rows;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_IDENTIFICATION_REPORT_DETAIL)).post({
                  overview: overview
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref5 = _context5.sent;
                data = _ref5.data;
                rows = (data.result || []).map(function (dto) {
                  return _this5.selloutIdentificationDetailDTOConverter.toObject(dto, jsonConversions);
                });
                return _context5.abrupt("return", [rows, data.overview.pagination.totalCount]);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                logger.error(_context5.t0);
                return _context5.abrupt("return", Promise.reject(_context5.t0));

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 9]]);
      }));
    }
    /**
     * Exports sellout identification report, Returns progress monitor indicating progress of export to xslx
     */

  }, {
    key: "getSelloutIdentificationReportDetailExport",
    value: function getSelloutIdentificationReportDetailExport(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", api("".concat(CONSTANTS.API.ENDPOINTS.EXPORT_SELLOUT_IDENTIFICATION_REPORT_DETAIL)).post(params).then(function (response) {
                  return response.data;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
    /**
     * Fetches DTOs for price elasticity report
     */

  }, {
    key: "getPriceElasticityReport",
    value: function getPriceElasticityReport(categoryId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _ref6, data;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.PRICE_ELASTICITY_REPORT)).get({
                  params: {
                    categoryId: categoryId
                  }
                });

              case 3:
                _ref6 = _context7.sent;
                data = _ref6.data;
                return _context7.abrupt("return", data);

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);
                logger.error(_context7.t0);
                return _context7.abrupt("return", Promise.reject(_context7.t0));

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 8]]);
      }));
    }
    /**
     * Clears cached data on BE
     */

  }, {
    key: "clearPriceElasticityReport",
    value: function clearPriceElasticityReport(categoryId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.PRICE_ELASTICITY_REPORT_CLEAR)).get({
                  responseType: 'json',
                  params: {
                    categoryId: categoryId
                  }
                });

              case 3:
                _context8.next = 9;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8["catch"](0);
                logger.error(_context8.t0);
                return _context8.abrupt("return", Promise.reject(_context8.t0));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 5]]);
      }));
    }
    /**
     * Fetches DTOs for sellout termination report with AG Grid filtering.
     *
     * @param topFilter
     * @param gridFilter
     * @param offset
     * @param limit
     * @returns
     */

  }, {
    key: "getSelloutTerminationReport",
    value: function getSelloutTerminationReport(topFilter, gridFilter, offset, limit) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this6 = this;

        var endpoint, _ref7, data;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_REPORT);
                _context9.next = 4;
                return api(endpoint).post({
                  topFilter: this.selloutTerminationReportFilterDTOConverter.toDocument(topFilter, jsonConversions),
                  gridFilter: gridFilter,
                  offset: offset,
                  limit: limit
                }, {
                  responseType: 'json'
                });

              case 4:
                _ref7 = _context9.sent;
                data = _ref7.data;
                return _context9.abrupt("return", List(data.result.map(function (row) {
                  return _this6.selloutTerminationReportRowDTOConverter.toObject(row, jsonConversions);
                })));

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);
                logger.error(_context9.t0);
                return _context9.abrupt("return", Promise.reject(_context9.t0));

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));
    }
    /**
     *
     */

  }, {
    key: "exportSelloutTerminationReport",
    value: function exportSelloutTerminationReport(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var endpoint, _ref8, data;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_TERMINATION_REPORT_EXPORT);
                _context10.next = 4;
                return api(endpoint).post({
                  filter: filter
                }, {
                  responseType: 'json'
                });

              case 4:
                _ref8 = _context10.sent;
                data = _ref8.data;
                return _context10.abrupt("return", data);

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](0);
                logger.error(_context10.t0);
                return _context10.abrupt("return", Promise.reject(_context10.t0));

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 9]]);
      }));
    }
    /**
     * Fetches DTOs for sellout impact report.
     *
     * @param filter
     * @returns
     */

  }, {
    key: "getSelloutImpactReport",
    value: function getSelloutImpactReport(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var _this7 = this;

        var endpoint, _ref9, data;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_IMPACT_REPORT);
                _context11.next = 4;
                return api(endpoint).post({
                  filter: this.selloutImpactReportFilterDTOConverter.toDocument(filter, jsonConversions)
                }, {
                  responseType: 'json'
                });

              case 4:
                _ref9 = _context11.sent;
                data = _ref9.data;
                return _context11.abrupt("return", List(data.result.map(function (row) {
                  return _this7.commonReleaseOverviewConverter.toObject(row, jsonConversions);
                })));

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](0);
                logger.error(_context11.t0);
                return _context11.abrupt("return", Promise.reject(_context11.t0));

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 9]]);
      }));
    }
    /**
     * Generates detail of sellout impact report.
     *
     * @param filter
     * @returns
     */

  }, {
    key: "generateSelloutImpactReportDetail",
    value: function generateSelloutImpactReportDetail(filter, releaseIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var endpoint, _ref10, data;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_IMPACT_REPORT_GENERATE);
                _context12.next = 4;
                return api(endpoint).post({
                  filter: this.selloutImpactReportFilterDTOConverter.toDocument(filter, jsonConversions),
                  releaseIds: releaseIds.toArray()
                }, {
                  responseType: 'json'
                });

              case 4:
                _ref10 = _context12.sent;
                data = _ref10.data;
                return _context12.abrupt("return", data);

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12["catch"](0);
                logger.error(_context12.t0);
                return _context12.abrupt("return", Promise.reject(_context12.t0));

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 9]]);
      }));
    }
    /**
     * Fetches DTOs for sellout impact report detail - 4Box view.
     *
     * @param reportId
     * @returns
     */

  }, {
    key: "getSelloutImpactReportDetail4Box",
    value: function getSelloutImpactReportDetail4Box(reportId, aggregations) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var _this8 = this;

        var endpoint, _ref11, data;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_IMPACT_REPORT_DETAIL_4BOX(reportId));
                _context13.next = 4;
                return api(endpoint).post({
                  aggregations: aggregations.toArray()
                });

              case 4:
                _ref11 = _context13.sent;
                data = _ref11.data;
                return _context13.abrupt("return", List(data.result.map(function (row) {
                  return _this8.selloutImpactReportDetailRow4BOXDTOConverter.toObject(row, jsonConversions);
                })));

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);
                logger.error(_context13.t0);
                return _context13.abrupt("return", Promise.reject(_context13.t0));

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 9]]);
      }));
    }
    /**
     * Fetches DTOs for sellout impact report detail - Release view.
     *
     * @param reportId
     * @returns
     */

  }, {
    key: "getSelloutImpactReportDetailRelease",
    value: function getSelloutImpactReportDetailRelease(reportId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var _this9 = this;

        var endpoint, _ref12, data;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_IMPACT_REPORT_DETAIL_RELEASE(reportId));
                _context14.next = 4;
                return api(endpoint).get();

              case 4:
                _ref12 = _context14.sent;
                data = _ref12.data;
                return _context14.abrupt("return", List(data.result.map(function (row) {
                  return _this9.selloutImpactReportDetailRowReleaseDTOConverter.toObject(row, jsonConversions);
                })));

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14["catch"](0);
                logger.error(_context14.t0);
                return _context14.abrupt("return", Promise.reject(_context14.t0));

              case 13:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[0, 9]]);
      }));
    }
  }]);

  return ReportLayer;
}();

__decorate([Inject, __metadata("design:type", PriceChangeReportDTOConverter)], ReportLayer.prototype, "priceChangeReportDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", PriceStickersReportDTOConverter)], ReportLayer.prototype, "priceStickersReportDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutIdentificationDTOConverter)], ReportLayer.prototype, "selloutIdentificationDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutIdentificationDetailDTOConverter)], ReportLayer.prototype, "selloutIdentificationDetailDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", CompetitorPriceChangeReportDTOConverter)], ReportLayer.prototype, "competitorPriceChangeReportDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutTerminationReportFilterDTOConverter)], ReportLayer.prototype, "selloutTerminationReportFilterDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutTerminationReportRowDTOConverter)], ReportLayer.prototype, "selloutTerminationReportRowDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutImpactReportFilterDTOConverter)], ReportLayer.prototype, "selloutImpactReportFilterDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", CommonReleaseOverviewConverter)], ReportLayer.prototype, "commonReleaseOverviewConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutImpactReportDetailRow4BOXDTOConverter)], ReportLayer.prototype, "selloutImpactReportDetailRow4BOXDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SelloutImpactReportDetailRowReleaseDTOConverter)], ReportLayer.prototype, "selloutImpactReportDetailRowReleaseDTOConverter", void 0);